import ChevronDownIcon from "@atlaskit/icon/core/chevron-down";
import {AnankeText} from "@vesta/ananke/components/anankeText";
import {AnankeDropdownItem} from "@vesta/ananke/components/anankeDropdownItem";
import {AnankeDropdownItemGroup} from "@vesta/ananke/components/anankeDropdownItemGroup";
import {AnankeDropdownMenu} from "@vesta/ananke/components/anankeDropdownMenu";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {CustomerProfileLifecycleOption} from "~/components/entityProfile/customerProfileDataSource/types";

export function ProfileCustomerEventsLifecycleFilterPill({
    options,
    value,
    onChange,
    isDisabled = false,
}: {
    options: Array<CustomerProfileLifecycleOption>;
    value: Uuid | null;
    onChange: (next: Uuid) => void;
    isDisabled?: boolean;
}) {
    const selectedLabel = options.find((option) => option.id === value)?.label ?? "Lifecycle";

    return (
        <AnankeDropdownMenu<HTMLButtonElement>
            placement="bottom-start"
            isDisabled={isDisabled === true || options.length === 0}
            trigger={({triggerRef, ...triggerProps}) => (
                <button
                    type="button"
                    {...triggerProps}
                    ref={triggerRef}
                    disabled={isDisabled === true || options.length === 0}
                    className="inline-flex min-w-0 shrink-0 items-center gap-x-ds-space-050 rounded-[4px] border border-solid border-ds-border bg-ds-surface px-ds-space-100 py-ds-space-075 disabled:cursor-default disabled:opacity-60"
                >
                    <AnankeText size="small">{selectedLabel}</AnankeText>
                    <ChevronDownIcon label="" size="small" />
                </button>
            )}
        >
            <AnankeDropdownItemGroup>
                {options.map((option) => (
                    <AnankeDropdownItem
                        key={option.id}
                        isSelected={option.id === value}
                        onClick={() => {
                            onChange(option.id);
                        }}
                    >
                        {option.label}
                    </AnankeDropdownItem>
                ))}
            </AnankeDropdownItemGroup>
        </AnankeDropdownMenu>
    );
}

export function ProfileCustomerEventsTabFilters({
    lifecycleOptions,
    selectedLifecycleId,
    onLifecycleChange,
    isLifecycleDisabled = false,
}: {
    lifecycleOptions: Array<CustomerProfileLifecycleOption>;
    selectedLifecycleId: Uuid | null;
    onLifecycleChange: (next: Uuid) => void;
    isLifecycleDisabled?: boolean;
}) {
    return (
        <div className="flex w-full min-w-0 flex-wrap items-center gap-ds-space-100">
            <ProfileCustomerEventsLifecycleFilterPill
                options={lifecycleOptions}
                value={selectedLifecycleId}
                onChange={onLifecycleChange}
                isDisabled={isLifecycleDisabled}
            />
        </div>
    );
}
